import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'reactstrap';
import { connect } from 'react-redux';
import api from '../../../../Api.js';

export function RemoveCompanyModal({ isOpen, openModal, toggle, companyId, onRemoved, onBack, notify, translate = {} }){
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [companyName, setCompanyName] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setError(null);
      setCompanyName(null);
      if (!(openModal || isOpen) || !companyId) return;
      setLoading(true);
      try {
        const resp = await api.getCompany(companyId).catch(() => null);
        const data = resp && resp.data ? resp.data : null;
        if (!mounted) return;
        setCompanyName(data ? (data.name || data.company_name || `Unidade #${companyId}`) : `Unidade #${companyId}`);
      } catch (err) {
        if (!mounted) return;
        setError(true);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, [isOpen, companyId]);

  const handleConfirm = async () => {
    if (!companyId) return;
    setDeleting(true);
    try {
      const resp = await api.deleteCompany(companyId).catch(() => null);
      if (resp && (resp.status === 200 || resp.status === 204 || (resp.data && resp.data.status === 200))) {
        const options = {place: "tr", message: (
          <div className="alert-text"><span className="alert-title" data-notify="title">{translate['sucesso']}.</span><span data-notify="message">{translate['a_unidade_foi_removida']}</span></div>
        ), type: 'success', icon: "ni ni-check-bold", autoDismiss: 7};
        if (notify) notify(options);
        if (onRemoved) await onRemoved();
        else toggle && toggle();
      } else {
        setError(true);
        const options = {place: "tr", message: (<div className="alert-text"><span className="alert-title" data-notify="title">{translate['ops']}.</span><span data-notify="message">{translate['erro_ao_remover_unidade'] || 'Erro ao processar a solicitação.'}</span></div>), type: 'danger', icon: 'ni ni-bell-55', autoDismiss: 7};
        if (notify) notify(options);
      }
    } catch (err) {
      console.error('Erro ao remover unidade:', err);
      setError(true);
      const options = {place: "tr", message: (<div className="alert-text"><span className="alert-title" data-notify="title">{translate['ops']}.</span><span data-notify="message">{translate['erro_ao_remover_unidade'] || 'Erro ao processar a solicitação.'}</span></div>), type: 'danger', icon: 'ni ni-bell-55', autoDismiss: 7};
      if (notify) notify(options);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Modal className="modal-dialog-centered modal-danger" contentClassName="bg-gradient-danger" isOpen={isOpen}>
      <div className="modal-header">
        <h6 className="modal-title" id="modal-title-notification">{translate['sua_atencao_e_requirida'] || 'Sua atenção é requirida.'}</h6>
        <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={toggle}>
          <span aria-hidden={true}>×</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="py-3 text-center">
          <i className="fas fa-exclamation-triangle fa-x3" style={{fontSize:'45px'}}></i>
          <h4 className="heading mt-4">{translate['voce_deve_ler_isto'] || 'VOCÊ DEVE LER ISTO!'}</h4>
          {loading && (<p>{translate['carregando'] || 'Carregando...'}</p>)}
          {!loading && (
            <p>
              {translate['remover_unidade_confirm_text'] || 'Se você prosseguir, todos os dados da unidade serão removidos, essa ação é irreversível.'}
              {companyName && (<><br/><strong>{companyName}</strong></>)}
            </p>
          )}
          {error && (<p className="text-danger">{translate['erro_ao_remover_unidade'] || 'Erro ao processar a solicitação.'}</p>)}
        </div>
      </div>
      <div className="modal-footer d-flex justify-content-between w-100">
        <div>{onBack && (<Button color="link" className="text-white" onClick={onBack}><i className="fas fa-arrow-left mr-1"></i> {translate['voltar'] || 'Voltar'}</Button>)}</div>
        <div className="ml-auto d-flex align-items-center">
          <Button className="btn-white" color="default" type="button" disabled={deleting} onClick={handleConfirm}>{deleting ? (translate['removendo'] || 'Removendo...') : (translate['ok_remova'] || 'Ok, Remova')}</Button>
          <Button className="text-white ml-2" color="link" data-dismiss="modal" type="button" onClick={toggle}>{translate['cancelar_e_fechar'] || 'Cancelar e fechar'}</Button>
        </div>
      </div>
    </Modal>
  );
}

export default connect(state => ({ translate: state.translate }))(RemoveCompanyModal);
